"use client";

import { c as _c } from "react/compiler-runtime";
import { useLinkPreviewVariant } from "./LinkPreviewContext";
import { LinkPreviewCardLayout } from "./OpenGraphPreview";
import MarketplaceCompactCta from "./marketplace/MarketplaceCompactCta";
import MarketplaceDataHealthIcon from "./marketplace/MarketplaceDataHealthIcon";
import MarketplaceFullFooter from "./marketplace/MarketplaceFullFooter";
import MarketplaceItemPreviewMediaLink from "./marketplace/MarketplaceItemPreviewMediaLink";
import { DEFAULT_MARKETPLACE_TITLE } from "./marketplace/MarketplaceItemPreviewCard.constants";
import type { MarketplaceItemPreviewCardProps } from "./marketplace/MarketplaceItemPreviewCard.types";
import { buildMarketplaceCtaLabel, getMarketplaceBrand, resolvePreviewHref } from "./marketplace/MarketplaceItemPreviewCard.utils";
import MarketplaceOverlayActionButtons from "./marketplace/MarketplaceOverlayActionButtons";
import { getMarketplaceContainerClass } from "./marketplace/previewLayout";
const normalizeSpaceSeparatedText = (value: string): string => value.trim().replace(/\s+/g, " ");
const buildDisplayPriceParts = ({
  price,
  priceCurrency
}: {
  readonly price: string;
  readonly priceCurrency: string;
}) => {
  if (price.length === 0) {
    return {
      priceValueText: "",
      priceCurrencyText: "",
      ariaPriceText: ""
    };
  }
  let priceValueText = price;
  if (priceCurrency.length > 0) {
    const tokens = price.split(" ");
    const lastToken = tokens[tokens.length - 1];
    if (typeof lastToken === "string" && tokens.length > 1 && lastToken.toUpperCase() === priceCurrency.toUpperCase()) {
      const strippedPrice = tokens.slice(0, -1).join(" ").trim();
      if (strippedPrice.length > 0) {
        priceValueText = strippedPrice;
      }
    }
  }
  const ariaPriceText = priceCurrency.length > 0 ? `${priceValueText} ${priceCurrency}` : priceValueText;
  return {
    priceValueText,
    priceCurrencyText: priceCurrency,
    ariaPriceText
  };
};
export default function MarketplaceItemPreviewCard(t0) {
  const $ = _c(75);
  const {
    href,
    mediaUrl,
    mediaMimeType,
    price,
    priceCurrency,
    title,
    dataHealth,
    compact: t1,
    hideActions: t2
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const hideActions = t2 === undefined ? false : t2;
  const variant = useLinkPreviewVariant();
  let t3;
  if ($[0] !== href) {
    t3 = resolvePreviewHref(href);
    $[0] = href;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const resolvedPreviewHref = t3;
  let displayTitle;
  let hasPrice;
  let marketplaceBrand;
  let priceCurrencyText;
  let priceValueText;
  let t4;
  if ($[2] !== href || $[3] !== price || $[4] !== priceCurrency || $[5] !== title) {
    const normalizedPrice = typeof price === "string" ? normalizeSpaceSeparatedText(price) : "";
    const normalizedPriceCurrency = typeof priceCurrency === "string" ? normalizeSpaceSeparatedText(priceCurrency) : "";
    const {
      priceValueText: t5,
      priceCurrencyText: t6,
      ariaPriceText
    } = buildDisplayPriceParts({
      price: normalizedPrice,
      priceCurrency: normalizedPriceCurrency
    });
    priceValueText = t5;
    priceCurrencyText = t6;
    let t7;
    if ($[12] !== title) {
      t7 = typeof title === "string" ? title.trim() : "";
      $[12] = title;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    const normalizedTitle = t7;
    hasPrice = priceValueText.length > 0;
    const hasTitle = normalizedTitle.length > 0;
    displayTitle = hasTitle ? normalizedTitle : DEFAULT_MARKETPLACE_TITLE;
    marketplaceBrand = getMarketplaceBrand(href);
    t4 = buildMarketplaceCtaLabel({
      normalizedPrice: ariaPriceText,
      marketplaceBrand
    });
    $[2] = href;
    $[3] = price;
    $[4] = priceCurrency;
    $[5] = title;
    $[6] = displayTitle;
    $[7] = hasPrice;
    $[8] = marketplaceBrand;
    $[9] = priceCurrencyText;
    $[10] = priceValueText;
    $[11] = t4;
  } else {
    displayTitle = $[6];
    hasPrice = $[7];
    marketplaceBrand = $[8];
    priceCurrencyText = $[9];
    priceValueText = $[10];
    t4 = $[11];
  }
  const ctaAriaLabel = t4;
  const shouldShowDataHealthIcon = dataHealth !== undefined && dataHealth.state !== "fresh";
  if (compact) {
    let t5;
    if ($[14] !== compact || $[15] !== variant) {
      t5 = getMarketplaceContainerClass(variant, compact);
      $[14] = compact;
      $[15] = variant;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    const t6 = `${t5} tw-relative`;
    let t7;
    if ($[17] !== dataHealth || $[18] !== shouldShowDataHealthIcon) {
      t7 = shouldShowDataHealthIcon && <MarketplaceDataHealthIcon dataHealth={dataHealth} />;
      $[17] = dataHealth;
      $[18] = shouldShowDataHealthIcon;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    let t8;
    if ($[20] !== mediaMimeType || $[21] !== mediaUrl || $[22] !== resolvedPreviewHref) {
      t8 = <MarketplaceItemPreviewMediaLink mediaMimeType={mediaMimeType} mediaUrl={mediaUrl} resolvedPreviewHref={resolvedPreviewHref} />;
      $[20] = mediaMimeType;
      $[21] = mediaUrl;
      $[22] = resolvedPreviewHref;
      $[23] = t8;
    } else {
      t8 = $[23];
    }
    const t9 = priceCurrencyText || undefined;
    let t10;
    if ($[24] !== ctaAriaLabel || $[25] !== hasPrice || $[26] !== hideActions || $[27] !== marketplaceBrand || $[28] !== priceValueText || $[29] !== resolvedPreviewHref || $[30] !== t9) {
      t10 = <MarketplaceCompactCta resolvedPreviewHref={resolvedPreviewHref} ctaAriaLabel={ctaAriaLabel} hideActions={hideActions} hasPrice={hasPrice} priceValueText={priceValueText} priceCurrencyText={t9} marketplaceBrand={marketplaceBrand} />;
      $[24] = ctaAriaLabel;
      $[25] = hasPrice;
      $[26] = hideActions;
      $[27] = marketplaceBrand;
      $[28] = priceValueText;
      $[29] = resolvedPreviewHref;
      $[30] = t9;
      $[31] = t10;
    } else {
      t10 = $[31];
    }
    let t11;
    if ($[32] !== hideActions || $[33] !== href || $[34] !== resolvedPreviewHref) {
      t11 = !hideActions && <MarketplaceOverlayActionButtons href={href} resolvedPreviewHref={resolvedPreviewHref} />;
      $[32] = hideActions;
      $[33] = href;
      $[34] = resolvedPreviewHref;
      $[35] = t11;
    } else {
      t11 = $[35];
    }
    let t12;
    if ($[36] !== t10 || $[37] !== t11 || $[38] !== t6 || $[39] !== t7 || $[40] !== t8) {
      t12 = <div className={t6} data-testid="manifold-item-card">{t7}{t8}{t10}{t11}</div>;
      $[36] = t10;
      $[37] = t11;
      $[38] = t6;
      $[39] = t7;
      $[40] = t8;
      $[41] = t12;
    } else {
      t12 = $[41];
    }
    let t13;
    if ($[42] !== href || $[43] !== t12 || $[44] !== variant) {
      t13 = <LinkPreviewCardLayout href={href} variant={variant} hideActions={true}>{t12}</LinkPreviewCardLayout>;
      $[42] = href;
      $[43] = t12;
      $[44] = variant;
      $[45] = t13;
    } else {
      t13 = $[45];
    }
    return t13;
  }
  let t5;
  if ($[46] !== compact || $[47] !== variant) {
    t5 = getMarketplaceContainerClass(variant, compact);
    $[46] = compact;
    $[47] = variant;
    $[48] = t5;
  } else {
    t5 = $[48];
  }
  const t6 = `${t5} tw-relative`;
  let t7;
  if ($[49] !== dataHealth || $[50] !== shouldShowDataHealthIcon) {
    t7 = shouldShowDataHealthIcon && <MarketplaceDataHealthIcon dataHealth={dataHealth} />;
    $[49] = dataHealth;
    $[50] = shouldShowDataHealthIcon;
    $[51] = t7;
  } else {
    t7 = $[51];
  }
  let t8;
  if ($[52] !== mediaMimeType || $[53] !== mediaUrl || $[54] !== resolvedPreviewHref) {
    t8 = <MarketplaceItemPreviewMediaLink mediaMimeType={mediaMimeType} mediaUrl={mediaUrl} resolvedPreviewHref={resolvedPreviewHref} />;
    $[52] = mediaMimeType;
    $[53] = mediaUrl;
    $[54] = resolvedPreviewHref;
    $[55] = t8;
  } else {
    t8 = $[55];
  }
  const t9 = priceCurrencyText || undefined;
  let t10;
  if ($[56] !== ctaAriaLabel || $[57] !== displayTitle || $[58] !== hasPrice || $[59] !== hideActions || $[60] !== href || $[61] !== marketplaceBrand || $[62] !== priceValueText || $[63] !== resolvedPreviewHref || $[64] !== t9) {
    t10 = <MarketplaceFullFooter href={href} resolvedPreviewHref={resolvedPreviewHref} displayTitle={displayTitle} ctaAriaLabel={ctaAriaLabel} hideActions={hideActions} hasPrice={hasPrice} priceValueText={priceValueText} priceCurrencyText={t9} marketplaceBrand={marketplaceBrand} />;
    $[56] = ctaAriaLabel;
    $[57] = displayTitle;
    $[58] = hasPrice;
    $[59] = hideActions;
    $[60] = href;
    $[61] = marketplaceBrand;
    $[62] = priceValueText;
    $[63] = resolvedPreviewHref;
    $[64] = t9;
    $[65] = t10;
  } else {
    t10 = $[65];
  }
  let t11;
  if ($[66] !== t10 || $[67] !== t6 || $[68] !== t7 || $[69] !== t8) {
    t11 = <div className={t6} data-testid="manifold-item-card">{t7}{t8}{t10}</div>;
    $[66] = t10;
    $[67] = t6;
    $[68] = t7;
    $[69] = t8;
    $[70] = t11;
  } else {
    t11 = $[70];
  }
  let t12;
  if ($[71] !== href || $[72] !== t11 || $[73] !== variant) {
    t12 = <LinkPreviewCardLayout href={href} variant={variant} hideActions={true}>{t11}</LinkPreviewCardLayout>;
    $[71] = href;
    $[72] = t11;
    $[73] = variant;
    $[74] = t12;
  } else {
    t12 = $[74];
  }
  return t12;
}